/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'deleteCustomerRequestLimitsBySystemGameId',
    message: messages.SUCCESS_DELETE_CUSTOMER_REQUEST_LIMITS_BY_SYSTEM_GAME_ID,
    method: 'DELETE',
    path: '/customer/:customerId/request-limits/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_REQUEST_LIMIT,
    requestSchema: requestSchemas.customerRequestLimits.deleteCustomerRequestLimitsBySystemGameId,
  },
  {
    action: 'getCustomerRequestLimitPackageByCompositeKey',
    message: messages.SUCCESS_GET_CUSTOMER_REQUEST_LIMIT_PACKAGE_BY_COMPOSITE_KEY,
    method: 'GET',
    path: '/customer/:customerId/request-limit-package/:compositeKey',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_REQUEST_LIMIT_PACKAGE,
    requestSchema: requestSchemas.customerRequestLimits.getCustomerRequestLimitPackageByCompositeKey,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'getCustomerRequestLimitsBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_REQUEST_LIMITS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/request-limits/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_REQUEST_LIMIT,
    requestSchema: requestSchemas.customerRequestLimits.getCustomerRequestLimitsBySystemGameId,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'saveCustomerRequestLimitsBySystemGameId',
    message: messages.SUCCESS_SAVE_CUSTOMER_REQUEST_LIMITS_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/request-limits/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.SAVE_CUSTOMER_REQUEST_LIMIT,
    requestSchema: requestSchemas.customerRequestLimits.saveCustomerRequestLimitsBySystemGameId,
  },
];
